/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DealsRouteImport } from './routes/deals'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DealsDealIdRouteImport } from './routes/deals_.$dealId'
import { Route as CasesCaseNumberRouteImport } from './routes/cases.$caseNumber'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DealsRoute = DealsRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DealsDealIdRoute = DealsDealIdRouteImport.update({
  id: '/deals_/$dealId',
  path: '/deals/$dealId',
  getParentRoute: () => rootRouteImport,
} as any)
const CasesCaseNumberRoute = CasesCaseNumberRouteImport.update({
  id: '/cases/$caseNumber',
  path: '/cases/$caseNumber',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/deals': typeof DealsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/cases/$caseNumber': typeof CasesCaseNumberRoute
  '/deals/$dealId': typeof DealsDealIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/deals': typeof DealsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/cases/$caseNumber': typeof CasesCaseNumberRoute
  '/deals/$dealId': typeof DealsDealIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/deals': typeof DealsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/cases/$caseNumber': typeof CasesCaseNumberRoute
  '/deals_/$dealId': typeof DealsDealIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/deals'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/cases/$caseNumber'
    | '/deals/$dealId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/deals'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/cases/$caseNumber'
    | '/deals/$dealId'
  id:
    | '__root__'
    | '/'
    | '/deals'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/cases/$caseNumber'
    | '/deals_/$dealId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DealsRoute: typeof DealsRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  CasesCaseNumberRoute: typeof CasesCaseNumberRoute
  DealsDealIdRoute: typeof DealsDealIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deals': {
      id: '/deals'
      path: '/deals'
      fullPath: '/deals'
      preLoaderRoute: typeof DealsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deals_/$dealId': {
      id: '/deals_/$dealId'
      path: '/deals/$dealId'
      fullPath: '/deals/$dealId'
      preLoaderRoute: typeof DealsDealIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cases/$caseNumber': {
      id: '/cases/$caseNumber'
      path: '/cases/$caseNumber'
      fullPath: '/cases/$caseNumber'
      preLoaderRoute: typeof CasesCaseNumberRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DealsRoute: DealsRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  CasesCaseNumberRoute: CasesCaseNumberRoute,
  DealsDealIdRoute: DealsDealIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
